import { SkaldElement, useSkaldElements } from '@skaldaura/devkit'
import { PBoldExt } from 'components/myTags/myTags'
import englishCondition from 'pages/visiteur/englishAssert'
import { useSelector } from 'react-redux'
import { Colors } from 'styles/colors'
import Categorie from './categorie'

interface IProps {
   visiteur?:boolean
}


export default function Produits(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const [categories] = useSkaldElements(englishCondition(lang, props.visiteur) ? "Product range" : "Produits")
   const bloc1Style = {
      padding: '0px 50px 0 80px',
   }

   return (
      <>
         <div style={{ height: 1520, background: Colors.white }}>
            <div style={bloc1Style} className='flex column between alignStart'>
               {categories.map((category: SkaldElement, index: number) => {
                  let color
                  switch (index) {
                     case 1:
                        color = Colors.gris1
                        break
                     case 2:
                        color = Colors.bleu
                        break
                     default:
                        color = Colors.corail
                        break
                  }
                  return (
                     <div key={index} className='w100'>
                        <PBoldExt color={color} fontSize='30px'>
                           {category.value}
                        </PBoldExt>
                        <Categorie lang={lang} color={color} categorie={category} />
                     </div>
                  )
               })}
            </div>
         </div>
      </>
   )
}
